import { createContext } from 'react';

/** Valeur du sélecteur « Tous les sites » de la maquette. */
export const TOUS_LES_SITES = 'TOUS';

export interface ContextePerimetre {
  /** Code de site courant, ou `TOUS`. */
  site: string;
  definirSite: (code: string) => void;
}

export const ContextePerimetreSites = createContext<ContextePerimetre | null>(null);
